import React from "react";
import { Section } from "./Section";

const STEPS = [
  {
    id: "step-discover",
    n: "01",
    title: "Discover",
    description:
      "We audit your current stack, listen to your team and identify the high-leverage problems worth solving first.",
  },
  {
    id: "step-design",
    n: "02",
    title: "Design",
    description:
      "Architecture diagrams, runbooks and SLAs — written in plain English before a single change is made.",
  },
  {
    id: "step-deploy",
    n: "03",
    title: "Deploy",
    description:
      "We migrate, automate and harden — in stages, with rollback plans and zero surprise downtime.",
  },
  {
    id: "step-operate",
    n: "04",
    title: "Operate",
    description:
      "24/7 monitoring, monthly reviews and a named engineer who knows your environment by heart.",
  },
];

export const Process = () => {
  return (
    <Section id="approach" className="bg-zinc-950 py-24 lg:py-32 border-t border-white/5">
      <div className="reveal-up max-w-2xl">
        <div className="text-xs uppercase tracking-[0.22em] text-[#FF4500] font-semibold">
          Our approach
        </div>
        <h2
          className="mt-4 text-4xl sm:text-5xl font-black tracking-[-0.02em] text-white"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          Four steps. Every engagement. No exceptions.
        </h2>
      </div>

      <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10 xl:gap-12">
        {STEPS.map((step) => (
          <div
            key={step.id}
            data-testid={step.id}
            className="reveal-up relative"
          >
            <div
              className="text-6xl font-black text-white/10 leading-none tracking-tighter"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              {step.n}
            </div>
            <div className="mt-4 h-px w-12 bg-[#FF4500]" />
            <h3
              className="mt-5 text-xl font-bold tracking-tight text-white"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              {step.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-zinc-400">
              {step.description}
            </p>
          </div>
        ))}
      </div>
    </Section>
  );
};

export default Process;
